<template>
  <span>
    <template v-if="isPercent">{{_toFixedForPer(num-0, 2, true, false, ifFormatter)}}%</template>
    <template v-else-if="isUnit">￥{{_toFixedForUnit(num-0, 2, ifFormatter)}}</template>
    <template v-else>{{_toFixedForUnit(num-0, 2, ifFormatter)}}</template>
  </span>
</template>
<script>
import { toFixedForUnit, toFixedForPer  } from 'kw-bweb-util'
export default {
  props: {
    num: {
      type: [Number, String],
      default: 0
    },
    dd: {
      type: Object,
      default: () => {}
    },
    isPercent: {
      type: Boolean,
      default: false,
    },
    ifFormatter: {
      type: Boolean,
      default: false,
    },
    isUnit: {
      type: Boolean,
      default: true,
    },
  },
  methods: {
    _toFixedForUnit() {
      return toFixedForUnit(...arguments)
    },
    _toFixedForPer(){
      return toFixedForPer(...arguments)
    },
  }
}
</script>
